import App from "App";
import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);

const rootElement = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

root.render(rootElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
